import React from 'react'
import { DollarSign } from 'lucide-react'

interface BudgetData {
  projected: number
  realized: number
  variance: number
  varianceAmount: number
}

interface BudgetMetricsProps {
  budgetData: BudgetData
  formatCurrency: (amount: number) => string
  title?: string
  className?: string
}

export function BudgetMetrics({ 
  budgetData, 
  formatCurrency, 
  title = "Custo da Área",
  className = ""
}: BudgetMetricsProps) {
  return (
    <div className={`card animate-fade-in-up ${className}`}>
      <h3 className="font-display text-white font-bold mb-6 flex items-center gap-3 bg-gradient-to-r from-white to-brand-gray-light bg-clip-text text-transparent">
        <div className="p-2 rounded-monumenta bg-brand-primary/10">
          <DollarSign className="w-5 h-5 text-brand-primary" />
        </div>
        {title}
      </h3>
      <div className="space-y-4">
        <div className="space-y-3">
          <div className="flex justify-between items-center p-3 bg-brand-dark/30 rounded-monumenta">
            <span className="text-brand-gray-light font-body">Projetado</span>
            <span className="text-white font-display font-semibold">{formatCurrency(budgetData.projected)}</span>
          </div>
          <div className="flex justify-between items-center p-3 bg-brand-dark/30 rounded-monumenta">
            <span className="text-brand-gray-light font-body">Realizado</span>
            <span className="text-white font-display font-bold">{formatCurrency(budgetData.realized)}</span>
          </div>
          <div className="flex justify-between items-center p-3 bg-success/10 border border-success/20 rounded-monumenta">
            <span className="text-brand-gray-light font-body">Variação</span>
            <span className="text-success font-display font-bold">
              {formatCurrency(budgetData.varianceAmount)} ({(budgetData.variance * 100).toFixed(1)}%)
            </span>
          </div>
        </div>
        
        <div className="pt-4">
          <div className="w-full bg-brand-dark-lighter rounded-monumenta h-3 shadow-inner">
            <div 
              className="h-3 rounded-monumenta bg-gradient-to-r from-success to-success/80 shadow-monumenta transition-all duration-500" 
              style={{ width: `${Math.min(100, (1 + budgetData.variance) * 100)}%` }}
            ></div>
          </div>
          <p className="text-xs text-brand-gray font-body mt-2">
            Economia do orçamento
          </p>
        </div>
      </div>
    </div>
  )
}
